<template>
  <div :class="{'selected': filterString.result === address.addressText}">
    <span class="address-item__text">{{ address.addressText }}</span>
    <img
      v-if="useAddressItemIcon"
      :src="require(`../assets/icons/${addressItemIcon}`)"
      alt="caret right circle icon"
      class="address-item__icon"
    >
  </div>
</template>

<script>
export default {
  name: 'AddressListItem',

  props: {
    address: {
      type: Object,
      required: true
    },
    filterString: {
      type: String,
      default: ''
    },
    addressItemIcon: {
      type: String,
      default: 'caret-right-circle.svg'
    },
    useAddressItemIcon: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      icon: `../assets/icons/${this.brandIcon}`
    }
  }
}
</script>

<style lang="scss" scoped>
.selected {
  background-color: $address-selected-bg;
}

@media (max-width: $screen-md) {
  .address-item {
    &__text {
      font-size: 14px;
    }

    &__icon {
      height: 30px;
      width: 30px;
    }
  }
}
</style>
